import { BRAND_RESOURCES } from '@/constants/brand-resources';
import React, { useCallback, useMemo } from 'react';
import { useHideLogo } from '@laigu/component';
import { useAgentChatUrl } from '@laigu/store';
import style from './index.less';

function VersionTipText({ className, versionType = 'livechat' }) {
  const { agentChatUrl } = useAgentChatUrl();
  const more = BRAND_RESOURCES.helpCenterUrl;
  const { isHide } = useHideLogo();
  const learnMore = useCallback(() => {
    window.open(more);
  }, [more]);

  const livechatUrl = useMemo(() => {
    switch (versionType) {
      case 'robotCall':
        return agentChatUrl + '&subSource=sub_source_50';
      case 'livechat':
      default:
        return agentChatUrl + '&subSource=' + 'sub_source_9';
    }
  }, [versionType, agentChatUrl]);

  const livechat = useCallback(() => {
    window.open(livechatUrl);
  }, [livechatUrl]);

  if (isHide) return null;

  return (
    <div className={`${style.tip} ${className}`}>
      {'如有更多问题可联系'}
      <span onClick={livechat}>{'在线客服'}</span>
      {',对比'}
      <span onClick={learnMore}>{'了解更多'}</span>
      {'信息'}
    </div>
  );
}

export default VersionTipText;
